import { useState, useEffect } from "react";
import WPAPI from "wpapi";

import theme from "../theme.js";
import { formatPostType } from "../util/conversion";

export const getEndpointProperty = (id) => {
  return document.getElementById(id) && document.getElementById(id).innerText;
};

export const wp = new WPAPI({
  endpoint: getEndpointProperty("endpoint") || "https://medienbildung-muenchen.de/wp-json/",
  nonce: getEndpointProperty("nonce"),
});

wp["route"] = wp.registerRoute("mebm/v1", "/route");
wp["menus"] = wp.registerRoute("mebm/v1", "/menus/(?P<id>[a-zA-Z0-9_-]+)");
wp["search"] = wp.registerRoute("mebm/v1", "/search");
wp["tax_by_slugs"] = wp.registerRoute("mebm/v1", "/tax_by_slugs");
wp["sitemap"] = wp.registerRoute("mebm/v1", "/sitemap");
wp["tribe_eventss"] = wp.registerRoute("tribe/events/v1", "/events/(?P<id>[a-zA-Z0-9_-]+)");
wp["mebm_tools"] = wp.registerRoute("wp/v2", "/mebm_tool/(?P<id>[a-zA-Z0-9_-]+)");
wp["mebm_rental_medias"] = wp.registerRoute("wp/v2", "/mebm_rental_media/(?P<id>[a-zA-Z0-9_-]+)");
wp["mebm_tutorials"] = wp.registerRoute("wp/v2", "/mebm_tutorials/(?P<id>[a-zA-Z0-9_-]+)");
wp["contact"] = wp.registerRoute("mebm/v1", "/contact");
wp["formToken"] = wp.registerRoute("mebm/v1", "/form-token");

export const getWpRoute = () => {
  let wpRoute;
  const location = window.location;

  // if (document.getElementById('wordpress-route-content') === null) {
  //   return { wpRoute, location };
  // }

  try {
    wpRoute = JSON.parse(document.getElementById("wordpress-route-content").dataset["wproute"]);
  } catch (e) {
    return console.error(e);
  }

  if (location.pathname === "/" && location.search.trim() === "") {
    wpRoute["is_home"] = true;
    wpRoute["is_page"] = false;
    wpRoute["is_singular"] = false;
  }
  return { wpRoute, location };
};

export const getMonth = () => {
  return document.getElementById("wordpress-route-content").dataset["month"];
};

export const getFeaturedMedia = () => {
  let featuredMedia;

  let rootElement = document.getElementById("wordpress-route-content");

  return {
    src: rootElement.dataset["featuredImageSrc"],
    width: rootElement.dataset["featuredImageWidth"],
    height: rootElement.dataset["featuredImageHeight"],
  };
};

export const usePost = ({ postType, slug, id }) => {
  const [post, setPost] = useState(undefined);
  const [password, setPassword] = useState(undefined);

  useEffect(() => {
    const postCopy = Object.assign({}, post);
    setPost(undefined);

    if (id) {
      setPost(undefined);
      let req = wp[`${postType}s`]().embed().id(id);

      if (password && req.password) {
        req = req.password(password);
      }

      req
        .then((p) => setPost(formatPostType(p, postType)))
        .catch((e) => {
          setPost(postCopy);
        });
    } else {
      let req = wp[`${postType}s`]().embed().slug(slug);

      if (password && req.password) {
        req = req.password(password);
      }

      req
        .then((posts) => setPost(posts && formatPostType(posts[0], postType)))
        .catch(() => {
          setPost(postCopy);
        });
    }
  }, [postType, slug, id, password]);

  return [post, setPassword];
};

export const usePosts = (params) => {
  const [posts, setPosts] = useState(undefined);

  useEffect(() => {
    setPosts(undefined);

    let req = wp.posts();

    Object.keys(params).forEach((paramKey) => {
      req = req.param(paramKey, params[paramKey]);
    });

    req.then(setPosts);
  }, Object.keys(params).concat(Object.values(params)));

  return posts;
};

export const useIsAuthenticated = () => {
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    wp.users()
      .me()
      .then((resp) => {
        setAuthenticated(true);
      })
      .catch(() => {});
  }, []);

  return authenticated;
};

export const useMenu = (id) => {
  const [menu, setMenu] = useState(undefined);

  useEffect(() => {
    wp.menus()
      .id(id)
      .then((menu) => {
        setMenu(menu);
      })
      .catch(() => {});
  }, [id]);

  return menu;
};

export const useSitemap = () => {
  const [sitemap, setSitemap] = useState(undefined);

  useEffect(() => {
    wp.sitemap()
      .then((sitemap) => {
        setSitemap(JSON.parse(sitemap));
      })
      .catch(() => {});
  }, []);

  return sitemap;
};

export const useEvents = (params) => {
  const [events, setEvents] = useState(false);

  useEffect(() => {
    setEvents(undefined);

    let req = wp["tribe_eventss"]();

    Object.keys(params).forEach((paramKey) => {
      req = req.param(paramKey, params[paramKey]);
    });

    req.then(({ events }) => {
      setEvents(
        events.map((event) => ({
          ...event,
          title: event.title,
          start: event["start_date"],
          end: event["end_date"],
          allDay: event["all_day"],
          textColor: theme["mebm-white"],
          backgroundColor: theme["mebm-green"],
          borderColor: theme["mebm-green"],
          url: event.url,
        }))
      );
    });
  }, Object.keys(params).concat(Object.values(params)));

  return events;
};
